import EditControl from './EditControl';

export default EditControl;
